import React, { useState } from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { Outlet } from 'react-router-dom';
import AdminHeader from './AdminHeader';
import AdminNavigation from './AdminNavigation';
import Breadcrumbs from './Breadcrumbs';

interface AdminLayoutProps {
  children?: React.ReactNode;
  title?: string;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children, title = '管理画面' }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleMenuClose = () => {
    setMobileMenuOpen(false);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      {/* AdminHeader は position: fixed なので、全幅で表示される */}
      <AdminHeader title={title} onMenuClick={handleMenuToggle} />

      {/* サイドバーナビゲーション */}
      <AdminNavigation
        open={isMobile ? mobileMenuOpen : true}
        onClose={handleMenuClose}
        variant={isMobile ? 'temporary' : 'permanent'}
      />

      {/* メインコンテンツエリア */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          backgroundColor: theme.palette.grey[50],
          minHeight: '100vh',
          // AdminHeaderの高さ分のマージン
          mt: { xs: '56px', sm: '64px' },
          // 左マージンは不要（Drawerが自動的にスペースを確保）
          width: '100%'
        }}
      >
        <Breadcrumbs />
        {children || <Outlet />}
      </Box>
    </Box>
  );
};

export default AdminLayout;
